import { SHOW_CASE_HISTORY } from "../constants";

export const hiddenReferralStatuses = [
    'waiting-for-payment-before-submission',
    'reserved'
]

// ! OLD
// export const showStatusHistoryButton = (item) => SHOW_CASE_HISTORY && item && item?.statusHistory && Array.isArray(item.statusHistory) && item.statusHistory.length > 0 && item.statusHistory.filter(i => i?.status && !hiddenReferralStatuses.includes(i.status)).length > 0 ? true : false;

export const showStatusHistoryButton = (item) => SHOW_CASE_HISTORY && item && item?.referralHistory && Array.isArray(item.referralHistory) && item.referralHistory.length > 0 ? true : false;